export type Milliseconds = number;
export const secondMs: Milliseconds = 1000;
export const minuteMs: Milliseconds = secondMs * 60;
export const hourMs: Milliseconds = minuteMs * 60;
export const dayMs: Milliseconds = hourMs * 24;
export const weekMs: Milliseconds = dayMs * 7;
export const yearMs: Milliseconds = dayMs * 365;

export type Seconds = number;
export const minuteS: Seconds = 60;
export const hourS: Seconds = minuteS * 60;
export const dayS: Seconds = hourS * 24;
export const weekS: Seconds = dayS * 7;
